import { Dimensions, Pixel } from './Enums';

declare global {
	interface Window {
		_paq?: any[];
	}
}

export class Tracker {
	private static canTrack = false;
	public static get consent() {
		return this.canTrack;
	}
	public static set consent(value: boolean) {
		this.canTrack = value;
		if (typeof fbq !== 'undefined') {
			fbq('consent', value ? 'grant' : 'revoke');
		}
	}

	public static addPixel(id: string): void {
		if (!this.canTrack) {
			return;
		}
		if (typeof fbq !== 'undefined') fbq('addPixelId', id);
	}

	public static event(event: string, payload?: any): void {
		if (!this.canTrack || !window._paq) return;
		const result: any[] = new Array(6).fill(undefined);

		// 0 : category (string) – Required Event category
		// 1 : action (string) – Required Event action
		// 2 : name (string) – Optional Event name
		// 3 : value (number) – Optional Event value
		// 4 : undefined
		// 5 : customDimensions (object) – Optional Custom dimensions
		result[0] = 'trackEvent';
		result[1] = event;
		if (payload?.event_id) result[2] = payload.event_id;
		if (payload?.event_name) result[3] = payload.event_name;

		const customDimensions: Record<string, string> = {};
		for (const dimension of Object.values(Dimensions)) {
			if (payload[dimension]) {
				customDimensions[dimension] = payload[dimension];
			}
		}
		result[5] = customDimensions;

		window._paq.push(result);
	}

	public static setViewmode(viewmode: string): void {
		if (!this.canTrack || !window._paq) return;
		window._paq.push(['setCustomDimensionValue', 5, `"${viewmode}"`]);
	}

	public static setWasPersonalised(waspersonalised: string): void {
		if (!this.canTrack || !window._paq) return;
		window._paq.push(['setCustomDimensionValue', 3, `"${waspersonalised}"`]);
	}

	public static pixel(event: (typeof Pixel)[keyof typeof Pixel], payload?: any): void {
		if (!this.canTrack || typeof fbq == 'undefined') {
			return;
		}

		fbq('track', event, payload);
	}

	public static pageView(payload: string): void {
		if (!this.canTrack || !window._paq) return;
		window._paq.push(['trackPageView', payload]);
	}
}
